import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  organizationSchema,
  type MeResponse,
  type Organization,
  type UpdateOrganization,
} from '@netdeck/contracts';
import { apiRequest } from '../../shared/api/client';
import { meQueryKey } from '../auth/api';

/**
 * Правка организации — сегодня это только её название (`PATCH /organization`).
 *
 * Слаг неизменяем и в запрос не входит: он уже разошёлся по ссылкам и по
 * именам потоков в go2rtc, и переименование сломало бы их молча.
 *
 * Ответ кладётся в профиль, а не перезапрашивается: название организации
 * живёт в `/auth/me`, оттуда его берёт шапка, и лишний круг к серверу
 * означал бы секунду со старым названием сразу после сохранения.
 */
export function useUpdateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateOrganization) =>
      apiRequest('/organization', organizationSchema, { method: 'PATCH', body: input }),
    onSuccess: (organization: Organization) => {
      queryClient.setQueryData(meQueryKey, (previous?: MeResponse) =>
        previous === undefined
          ? previous
          : {
              ...previous,
              organization: {
                ...previous.organization,
                name: organization.name,
              },
            },
      );
    },
  });
}
